import { createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';

import { ItineraryDetail, AirValidationFlightsSector } from '@seat-map/entities/itinerary-detail';
import { PassengersSeatMap, PassengersSeats, SavePassengers, SeatMap, SeatMapErrorsTypes } from '@seat-map/entities/seat-map';


export const fetchItineraryFlightAction = createAction(type('[SeatMap/API] Fetch itinerary flight'),
  props<{ itineraryId: string, flightIdx: number }>());
export const fetchItineraryFlightSuccessAction = createAction(type('[SeatMap/API] Fetch itinerary flight success'),
  props<{ itineraryDetail: ItineraryDetail }>());

export const selectSectorItineraryDetailAction = createAction(type('[SeatMap/API] select Sector itinerary detail'),
  props<{ sector: number }>());
export const selectFlightItineraryDetailAction = createAction(type('[SeatMap/API] select Flight itinerary detail'),
  props<{ flight: AirValidationFlightsSector }>());


export const fetchSeatMapFlightAction = createAction(type('[SeatMap/API] Fetch Seat map flight'),
  props<{
    itineraryId: number, airReservationId: number, flightIdx: number,
    passengers: PassengersSeatMap[], totalFlightIdx?: number
  }>());
export const fetchSeatMapFlightTokenAction = createAction(type('[SeatMap/API] Fetch Seat map flight token'),
  props<{
    itineraryId: number, airReservationId: number, flightIdx: number,
    passengers: PassengersSeatMap[], token: string, totalFlightIdx: number
  }>());
export const fetchSeatMapFlightActionSuccess = createAction(type('[SeatMap/API] Fetch Seat map flight success'),
  props<{ seatMap: SeatMap }>());

export const fetchSeatsPassengersInFlightAction = createAction(type('[SeatMap/API] Fetch seats passengers in flight'),
  props<{
    itineraryId: number, airReservationId: number, flightIdx: number,
    passengers: PassengersSeats[], totalFlightIdx?: number, token?: string
  }>());
export const fetchSeatsPassengersInFlightActionSuccess = createAction(type('[SeatMap/API] Fetch seats passengers flight success'),
  props<{ passengers: PassengersSeats[] }>());
export const selectPreviewSeatInFlightAction = createAction(type('[SeatMap/API] select preview seat in flight'),
  props<{ seatNumber: string }>());
export const removePreviewSeatInFlightAction = createAction(type('[SeatMap/API] remove preview seat in flight'),
  props<{ seatNumber: string }>());
export const selectSeatsInFlightAction = createAction(type('[SeatMap/API] select seats in flight'),
  props<{ seatNumbers: string[] }>());
export const removeSeatInFlightAction = createAction(type('[SeatMap/API] remove seat in flight'),
  props<{ seatNumber: string }>());

export const selectSeatPassengerInFlightAction = createAction(type('[SeatMap/API] select seat passenger in flight'),
  props<{ passenger: PassengersSeatMap, seatNumber: string }>());

export const fetchSaveSeatsPassengersInFlightAction = createAction(type('[SeatMap/API] fetch save seats passengers in flight'),
  props<{ seatMap: SeatMap, itinerary: ItineraryDetail, flightIdx: number, nextFlight: boolean }>());

export const fetchSaveSeatPassengersInFlightAction = createAction(type('[SeatMap/API] fetch save seat passengers in flight'),
  props<{ airReservationId: number, savePassengers: SavePassengers[], isReassigned?: boolean, isErrorInReassigned?: boolean }>());
export const fetchReassignedSeatPassengersInFlightAction =
  createAction(type('[SeatMap/API] fetch reassigned seat passengers in flight'),
    props<{ airReservationId: number, reassignedPassengers: SavePassengers[] }>());

export const fetchSaveSeatPassengersInFlightSuccessAction =
  createAction(type('[SeatMap/API] fetch save seat passengers in flight success'),
    props<{ itineraryId: number, flightIdx: number, passengersSeat: PassengersSeats }>());
export const fetchReassignedSeatPassengersInFlightSuccessAction =
  createAction(type('[SeatMap/API] fetch reassigned seat passengers in flight success'),
    props<{ itineraryId: number, flightIdx: number, passengersSeat: PassengersSeats }>());
export const fetchRemoveSeatPassengersInFlightSuccessAction =
  createAction(type('[SeatMap/API] fetch remove seat passengers in flight success'),
    props<{ itineraryId: number, flightIdx: number, passengersSeat: PassengersSeats }>());


export const fetchSaveSeatPassengersInFlightErrorAction =
  createAction(type('[SeatMap/API] fetch save seat passengers in flight error'),
    props<{ itineraryId: number, flightIdx: number, passengersSeat: PassengersSeats }>());
export const fetchReassignedSeatPassengersInFlightErrorAction =
  createAction(type('[SeatMap/API] fetch reassigned seat passengers in flight error'),
    props<{ itineraryId: number, flightIdx: number, passengersSeat: PassengersSeats }>());
export const fetchRemoveSeatPassengersInFlightErrorAction =
  createAction(type('[SeatMap/API] fetch remove seat passengers in flight error'),
    props<{ itineraryId: number, flightIdx: number, passengersSeat: PassengersSeats }>());

export const errorSeatMapAction = createAction(type('[SeatMap/Data] error seat map'),
  props<{ errorType: SeatMapErrorsTypes, currentFlightIdx?: number, totalFlightIdx?: number }>());
export const closeErrorSeatMapAction = createAction(type('[SeatMap/Data] close error seat map'));


export const saveTransactionsPassengersInFlightAction =
  createAction(type('[SeatMap/API] save transactions passengers in flight'),
    props<{ savePassengers: SavePassengers[] }>());

export const saveTransactionsPassengersInFlightSuccessAction =
  createAction(type('[SeatMap/API] save transactions passengers in flight success'),
    props<{ savePassengers: SavePassengers }>());

export const saveTransactionsPassengersInFlightErrorAction =
  createAction(type('[SeatMap/API] save transactions passengers in flight error'),
    props<{ savePassengers: SavePassengers }>());
